/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 10:45:51
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-20 11:29:17
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/paymentGateway/index.tsx
 */
import { get, post, remove } from 'src/tools/server';

// 获取页面country/region 和phone 的area 的接口
export const getPaymentGatewayList = () => {
  return get<any>(`/portal/store/setting/paymentGateway/list`, {});
};

export const getPaymentGatewayProviders = () => {
  return get<any>(`/portal/store/setting/paymentGateway/providers`, {});
};

export const newPaymentGateway = (gatewayProviderCode) => {
  return get<any>(
    `/portal/store/setting/paymentGateway/${gatewayProviderCode}/new`,
    {},
  );
};

export const savePaymentGateway = (data) => {
  return post<any>(`/portal/store/setting/paymentGateway`, data || {}, {});
};

export const getPaymentGatewayDetail = (paymentGatewayUuid) => {
  return get<any>(
    `/portal/store/setting/paymentGateway/${paymentGatewayUuid}`,
    {},
  );
};
export const deletePaymentGateway = (paymentGatewayUuid) => {
  return remove<any>(
    `/portal/store/setting/paymentGateway/${paymentGatewayUuid}`,
    {},
  );
};

export const paymentGatewayNameUsed = (data) => {
  return post<any>(`/portal/store/setting/paymentGateway/isNameUsed`, data, {});
};
